/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';
import { getApiPath } from '../../store-helpers';

const state = {
  zones: [],
};

const getters = {
  zones: state => state.zones,
};

const actions = {
  list({ commit }, payload) {
    // TODO: filter, limit has to be like this for now
    return Vue.http.get(`${getApiPath(payload.user)}/maps/zones`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      })
      .catch((error) => {
        console.log(error, 'failed to fetch zones');
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, zones) {
    state.zones = zones.data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/maps/zones.js